import elements from "../styles/settings/elements.module.scss";
import classes from "../styles/pages/contactPage.module.scss";
import {BsFillPersonFill, BsFillTelephoneFill} from "react-icons/bs";
import {MdEmail} from "react-icons/md";
import {Container} from "react-bootstrap";

function ContactPage(){
    return(
        <Container>
            <h1 className={elements.middleTitle}>Contact Info</h1>

            <div className={classes.infoBlock}>
                <p><BsFillPersonFill className={classes.icon_name}/> Maria</p>
                <p><BsFillTelephoneFill className={classes.icon_phone}/> <a href="tel:9808332222">9808332222</a></p>
                <p><MdEmail className={classes.icon_email}/> <a href="mailto:mariaskinboutique.com@gmail.com?subject = mariaskinboutique.com">mariaskinboutique.com@gmail.com</a></p>
                <p className={classes.info}>I would appreciate if you text me to contact, thank you!</p>
            </div>
        </Container>
    );
}

export default ContactPage;